import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CheckManager } from "../../shared/check-manager";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { Filter } from "../../models/filter.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { HouseDataProvider } from "../../data-provider/house.dp";
import { House } from "../../models/house.model";
import { Group } from "../../models/group.model";
import { SearchUtils } from "../../helper/search.helper";

let HouseListComponent = {
    selector: "vcHouseList",
    templateUrl: "/angular/components/house/house-list.component.html",
    bindings: {
        user: "=",
        street: "=",
        group: "=",
    },
    controller: class HouseListController {
        // * bindings for typescript compiler *
        public user: any;
        public street: any;
        public group: any;
        // ************************************

        private $scope: any;
        private $cookies: any;
        private dataProvider: HouseDataProvider;
        public navigationBarService: NavigationBarHelperService;
        private $interval: any;
        private permissionProvider: PermissionCheck;
        private searchUtils: SearchUtils;
        private toast: ToastUtils;
        private $q: any;
        private filterDataProvider: FilterDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private groupDataProvider: GroupDataProvider;
        private __env: any;
        private __app_type: string;
        private dialog: DialogUtils;
        private checkManager: CheckManager;
        private $filter: any;
        private readonly $timeout: any;
        private $location: any;
        public scrollViewOptions: any = {
            viewportOffset: [1000, 1000, 1000, 1000],
        };

        public selectedHouses = [];
        public buttonText: string;
        private filter: Filter;
        private isLeaderView: boolean;
        public warningBannerDismissed: boolean | undefined = undefined;
        public upgrade: object | null = null;
        private search: string;
        public essentialsMode: boolean;
        public subheading: string;
        public columns: object;
        public locationTypes: any;
        private searchDelay: number;
        private previousFilter: Filter;

        constructor(
            $scope: any,
            $cookies: any,
            HouseDataProvider: HouseDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            $interval: any,
            $q: any,
            PermissionCheck: PermissionCheck,
            SearchUtils: SearchUtils,
            ToastUtils: ToastUtils,
            FilterDataProvider: FilterDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            GroupDataProvider: GroupDataProvider,
            __env: object,
            __app_type: string,
            DialogUtils: DialogUtils,
            $filter: any,
            $timeout: any,
            $location: any
        ) {
            this.$scope = $scope;
            this.$cookies = $cookies;
            this.dataProvider = HouseDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.$interval = $interval;
            this.permissionProvider = PermissionCheck;
            this.searchUtils = SearchUtils;
            this.toast = ToastUtils;
            this.$q = $q;
            this.filterDataProvider = FilterDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.groupDataProvider = GroupDataProvider;
            this.__env = __env;
            this.__app_type = __app_type;
            this.dialog = DialogUtils;
            this.$filter = $filter;
            this.$timeout = $timeout;
            this.locationTypes = this.dataProvider.getLocationTypes();
            this.$location = $location;

            this.filterDataProvider.setPage("database");
            this.filter = this.filterDataProvider.appliedFilter;
            this.checkManager = this.dataProvider.checkManager;
            this.essentialsMode =
                this.campaignDataProvider.activeCampaign.campaignstatusid ==
                "5";
            this.isLeaderView = this.__app_type == "LEADER";
            this.warningBannerDismissed =
                this.$cookies.get("warningBannerDismissed") || false;
            this.subheading =
                "Your houses will display here when you import your " +
                this.__env.strings.voter_file +
                ".";

            this.permissionProvider.getFeaturePermissions().then(() => {
                if (
                    this.permissionProvider.hasPermission("ADD_HOUSE") &&
                    !this.essentialsMode
                ) {
                    this.buttonText = "Create House";
                }
            });

            // check if upgrade is pending
            this.campaignDataProvider
                .checkCampaignUpgradePending()
                .then((upgrade: object) => {
                    this.upgrade = upgrade;
                });
            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = _.cloneDeep(
                    this.filter.search.values
                );
                this.search = this.searchUtils.searchText;
            }

            this.dataProvider.getColumns().then((columns: object) => {
                this.columns = columns;
                this.dataProvider.getAll(0, false);
            });

            if (!this.isLeaderView) {
                this.searchUtils.setSearchBar(
                    "Search Houses",
                    (searchText: string) => {
                        this.search = searchText;
                        return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                    },
                    null,
                    true
                );
            }

            this.checkManager.checkAll(false);

            this.$scope.$watch(
                () => this.search,
                (
                    newValue: string | undefined,
                    oldValue: string | undefined
                ) => {
                    if (oldValue != newValue) {
                        this.dataProvider.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.filterDataProvider.filter.search.values =
                                this.search;
                        }, 1000);
                    }
                },
                true
            );
        }

        $onInit() {
            this.$scope.$watch(
                () => this.filter,
                (newValue: Filter, oldValue: Filter) => {
                    if (
                        !this.previousFilter ||
                        (Object.keys(newValue).length &&
                            !Object.keys(oldValue).length) ||
                        (newValue &&
                            !angular.equals(
                                newValue.nonEmptyValues(),
                                oldValue.nonEmptyValues()
                            ))
                    ) {
                        this.previousFilter = _.cloneDeep(newValue);
                        this.dataProvider.setFilters(
                            this.filter,
                            this.street,
                            this.group
                        );
                    }
                },
                true
            );
            this.$timeout(() => {
                if (this.filterDataProvider.isSearchActive()) {
                    this.searchUtils.searchText = angular.copy(
                        this.filterDataProvider.non_empty_applied_fitlers.search
                    );
                    this.navigationBarService.setSearchMode(true);
                }
            }, 500);
        }

        scrollLoad(offset: number): void {
            if (!this.dataProvider.scrollLoading) {
                this.dataProvider.getAll(offset, true);
            }
        }

        deleteHouseModal(ev: object): void {
            this.dialog
                .show({
                    component: "vc-bulk-delete",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        numItems:
                            this.dataProvider.checkManager.checked_items_count,
                        itemType: "house",
                        anonymize: false,
                    },
                })
                .then(() => {
                    this.dataProvider.bulkDelete(this.street).then(
                        () =>
                            this.toast.success(
                                "Bulk delete houses started, this may take a few minutes. You will be notified once it completes."
                            ),
                        () => this.toast.error()
                    );
                });
        }

        bulk_group(ev: object): void {
            this.dialog
                .show({
                    component: "vc-group-selection-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        provider: this.dataProvider,
                        street: this.street,
                    },
                })
                .then((group: Group) => {
                    this.checkManager.setLoading(true);

                    let filterCopy = this.dataProvider.addGroupToFilter(
                        this.filter,
                        this.group
                    );

                    let bulkActionData =
                        this.checkManager.bulkActionData(filterCopy);
                    bulkActionData["constituent_filters_select_all"] = true;
                    bulkActionData["data_type"] = "houses";
                    if (this.street && this.street.street) {
                        bulkActionData["filters"].street = this.street;
                    }
                    group
                        .addMembers({ members: [bulkActionData] }, this.dialog)
                        .then(
                            (group: Group) => {
                                this.checkManager.setLoading(false);
                                this.toast.success(
                                    "Houses added to " + group.gname
                                );
                                this.checkManager.checkAll(false);
                            },
                            (data: any) => {
                                this.checkManager.setLoading(false);
                                if (data.tooBig) {
                                    this.listTooBig();
                                } else {
                                    this.toast.error();
                                }
                            }
                        );
                });
        }

        showExport($event: object): void {
            if (this.permissionProvider.hasPermission("EXPORT")) {
                this.dialog
                    .show({
                        component: "vc-export-dialog",
                        scope: this.$scope,
                        size: "x-large",
                        targetEvent: $event,
                        locals: {
                            importDataType: this.street ? "people" : "houses",
                        },
                    })
                    .then((exportChoices: any) => {
                        this.dataProvider.bulkExport(exportChoices).then(
                            () => {
                                this.toast
                                    .action("Export Started", "Show")
                                    .then((value: string) => {
                                        if (value == "ok") {
                                            if (this.isLeaderView) {
                                                this.$location.url(
                                                    "/leader_exports"
                                                );
                                            } else {
                                                this.$location.url("/exports");
                                            }
                                        }
                                    });
                                this.checkManager.checkAll(false);
                            },
                            () => this.toast.error()
                        );
                    });
            } else {
                this.dialog.show({
                    component: "vc-export-disabled-dialog",
                    scope: this.$scope,
                    size: "large",
                    targetEvent: $event,
                });
            }
        }

        listTooBig(): void {
            this.checkManager.checkAll(false);
            const listToBigAlert = this.dialog
                .alert()
                .title(`List Too Big`)
                .htmlContent(
                    `<p class="no-margin">We cannot complete this action as it will result in exceeding the list size maximum of 20,000 ${this.__env.strings.voters}.</p>
                        <p class="no-margin">List limits are in place to prevent excessive mobile data usage and provide an optimal experience using the mobile app.</p>`
                )
                .escapeToClose(false)
                .ok("Close");
            this.dialog.show(listToBigAlert);
        }

        openCanvassDialog(house: House, ev: object): void {
            if (this.essentialsMode) {
                this.dialog.show({
                    component: "vc-feature-disabled-dialog",
                    targetEvent: ev,
                    size: "large",
                    scope: this.$scope,
                    locals: {
                        essentials: true,
                    },
                });
            } else {
                this.dialog
                    .show({
                        component: "vc-canvass-form",
                        targetEvent: ev,
                        scope: this.$scope,
                        locals: {
                            selectedHouseOccupant: null,
                            selectedHouse: house,
                            selectedCanvass: null,
                        },
                        size: "large",
                        ariaLabel: "Interaction",
                    })
                    .then((data: any) => {
                        house.setData(data.house);

                        house.cssid = data.cssid;
                        house.cssname = data.cssname;
                        house.csreception = data.csreception;
                        house.cscreationdatetime = data.cscreationdatetime;
                        house.cstype = "Walk";
                        house.csscolor = data.csscolor;
                        house.user = data.user;
                    });
            }
        }

        openBuildingDialog(house: House, ev: object): void {
            this.dialog
                .show({
                    component: "vc-view-building",
                    targetEvent: ev,
                    scope: this.$scope,
                    ariaLabel: "Building",
                    locals: {
                        bid: house.bid,
                    },
                    size: "large",
                })
                .then((data: object) => {
                    this.dataProvider.getAll(0, false);
                });
        }

        openViewHouseDialog(house: House, ev: object): void {
            this.dialog
                .show({
                    component: "vc-view-house",
                    targetEvent: ev,
                    scope: this.$scope,
                    ariaLabel: "View House",
                    size: "large",
                    locals: {
                        selectedHouse: house,
                        selectedHid: null,
                    },
                })
                .then((data: object) => {
                    house.setData(data);
                    this.dataProvider.getAll(0, false);
                });
        }

        openEditHouseDialog(house: House, ev: object): void {
            this.dialog
                .show({
                    component: "vc-house-form",
                    targetEvent: ev,
                    ariaLabel: "House",
                    scope: this.$scope,
                    locals: {
                        selectedHouse: house,
                    },
                    size: "x-large",
                })
                .then((editedHouse: House) => {
                    if (!house) {
                        this.dataProvider.addToFilteredHouses(editedHouse);
                    } else {
                        house.setData(editedHouse);
                    }
                });
        }

        removeFromGroup(ev: object): void {
            if (this.group) {
                this.dialog
                    .delete({
                        fullscreen: true,
                        targetEvent: ev,
                        locals: {
                            bodyText:
                                "They will be permanently removed from this list. The houses and the " +
                                this.__env.strings.voters +
                                " contained in them will remain in your database.",
                            title: `Remove houses from this list?`,
                        },
                    })
                    .then(() => {
                        this.checkManager.setLoading(true);
                        const filterCopy = this.dataProvider.addGroupToFilter(
                            this.filter,
                            this.group
                        );
                        const bulkActionData =
                            this.checkManager.bulkActionData(filterCopy);
                        bulkActionData["data_type"] = "houses";

                        this.groupDataProvider
                            .bulkRemove(this.group.gid, bulkActionData)
                            .then(
                                () => {
                                    this.dataProvider.resetItems();
                                    this.checkManager.setLoading(false);
                                    this.checkManager.checkAll(false);
                                    this.toast.success(
                                        "Houses removed from list"
                                    );
                                },
                                () => {
                                    this.toast.error();
                                }
                            );
                    });
            }
        }

        openViewUserDialog(uid: string | number, ev: object): void {
            this.dialog.show({
                component: "vc-view-organisation-user",
                targetEvent: ev,
                size: "large",
                scope: this.$scope,
                locals: {
                    selectedUser: null,
                    selectedUserId: uid,
                    editable: false,
                    onUserDeleted: null,
                    onUserUpdated: null,
                },
            });
        }

        upgradePending(): boolean {
            return !this.warningBannerDismissed && this.upgrade != null;
        }

        dismissBanner(): void {
            this.warningBannerDismissed = true;
            let expire = new Date();
            expire.setTime(
                expire.getTime() +
                    expire.getTimezoneOffset() * 12 * 60 * 60 * 1000
            );
            this.$cookies.put("warningBannerDismissed", 1, {
                expires: expire,
            });
        }
        openUpgradePlanDialog(conversionType: string, ev: object): void {
            if (this.permissionProvider.hasBillingRight()) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: conversionType,
                    },
                    fullscreen: true,
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.dialog.show({
                    component: "vc-no-permission-upgrade",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {},
                    size: "med",
                    style: "background: #f6f6f6",
                });
            }
        }
    },
};

angular
    .module("house")
    .component(HouseListComponent.selector, HouseListComponent);
